import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import Heading from 'components/Heading';
import { Link } from 'core/routing';

import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

export const ContentPreview = withNamespaces()(
  observer(({ activity }) => {
    const { content, object } = activity;
    if (content.type === 'issue') {
      return (
        <Main>
          <Link
            name={`${object.routeName}.issue`}
            params={Object.assign({}, object.routeParams, {
              issueSlug: content.slug,
            })}
          >
            <HeadingStyled level={2}>{content.title}</HeadingStyled>
          </Link>
        </Main>
      );
    }
    if (content.type === 'contribution') {
      const contributionId = content?.version;
      return (
        <Main>
          <Link
            name={`${object.routeName}.contribution`}
            params={Object.assign({}, object.routeParams, {
              contributionId,
            })}
          >
            <HeadingStyled level={2}>
              {content.title || (
                <Trans>Contribution #{{ contributionId }}</Trans>
              )}
            </HeadingStyled>
          </Link>
        </Main>
      );
    }
    return null;
  }),
);

const Main = styled.div`
  border: 1px solid ${props => props.theme.color.wfGrey200};
  padding: 16px;
  margin-top: 10px;
  width: 75%;
`;

const HeadingStyled = styled(Heading)`
  color: ${props => props.theme.color.wfGrey};
  margin: 0;
  &:hover {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
  }
  ${media.m`
    margin-left: 20px;
    width: 85%;
  `};
`;

ContentPreview.propTypes = {
  activity: PropTypes.object,
};
